'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useState } from 'react';
import { Icon } from './Icon';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from './ui/collapsible';
/**
 * Accordion - список раскрывающихся пунктов. На Collapsible пресета
 * (единица 15).
 *
 * ЧТО БЫЛО ДО. Плагин `HSAccordion` прежней библиотеки: раскрытие, высота и
 * `aria-expanded` держал скрипт, а класс `active` он ставил на разметку
 * мимо React. Вместе с библиотекой ушёл и плагин; состояние пункта живёт
 * там же, где всё остальное состояние продукта, - в компоненте.
 *
 * Роль та же, что у `Section`, но задача другая: `Section` - зона колонки
 * консоли с шапкой и действиями, `Accordion` - однородный список вопросов
 * (FAQ лендинга, витрина). Общего вида у них нет и быть не должно.
 */
export function Accordion({ children, alwaysOpen = true, className, }) {
    return (_jsx("div", { className: `divide-foreground/10 divide-y ${className ?? ''}`, "data-accordion-always-open": alwaysOpen ? '' : undefined, children: children }));
}
export function AccordionItem({ title, children, defaultOpen = false, toggleClassName = 'flex w-full items-center justify-between gap-4 py-4 text-start font-semibold', }) {
    const [open, setOpen] = useState(defaultOpen);
    const id = useId();
    const contentId = `${id}-content`;
    return (_jsxs(Collapsible, { open: open, onOpenChange: setOpen, id: id, children: [_jsxs(CollapsibleTrigger, { className: toggleClassName, "aria-controls": contentId, children: [title, _jsx(Icon, { name: "chevronDown", className: `shrink-0 transition-transform ${open ? 'rotate-180' : ''}` })] }), _jsx(CollapsibleContent, { id: contentId, role: "region", "aria-labelledby": id, children: children })] }));
}
//# sourceMappingURL=Accordion.js.map